import { render } from "./ForecastingPCODocuments.vue?vue&type=template&id=66035c5c&ts=true"
import script from "./ForecastingPCODocuments.vue?vue&type=script&lang=ts"
export * from "./ForecastingPCODocuments.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__